import React from "react"
import { FormattedMessage } from "react-intl"
import { ConversationStatus, STATUS_NEW, STATUS_IN_PROGRESS, STATUS_CLOSED } from "../../state/conversation/ConversationStatuses"

type OwnProps = {
    status: ConversationStatus
}
const ConversationStatusComponent = (props: OwnProps) => {
    return (
        <div className={"mr-1 badge text-with-icon badge-" + getLabelType(props.status)}>
            {getStatusLabel(props.status)}
        </div>
    )
}

export const getLabelType = (status: ConversationStatus) => {
    switch (status) {
    case STATUS_NEW:
        return "primary"
    case STATUS_IN_PROGRESS:
        return "warning"
    case STATUS_CLOSED:
        return "secondary"
    }
}

export const getStatusLabel = (status: ConversationStatus) => {
    switch(status) {
    case STATUS_NEW:
        return (
            <FormattedMessage
                id="conversation.status.new_label"
                defaultMessage="New"
            />
        )
    case STATUS_IN_PROGRESS:
        return (
            <FormattedMessage
                id="conversation.status.in_progress_label"
                defaultMessage="In progress"
            />
        )
    case STATUS_CLOSED:
        return (
            <FormattedMessage
                id="conversation.status.closed_label"
                defaultMessage="Closed"
            />
        )
    }
}
export default ConversationStatusComponent


// WEBPACK FOOTER //
// ./src/inbox/components/ConversationStatusComponent.tsx